import React from "react";
import { Form, Col } from "react-bootstrap";
import { useField } from "formik";

const BSelectField = (props) => {
    const {
        as,
        md,
        controlId,
        dropDownLabel,
        label,
        size,
        data,
        dataValue,
        dataLabel,
        dataDescription,
        ...rest
    } = props;
    const [field, meta] = useField(props);

    return (
        <Form.Group as={as} md={md} controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...rest}
                {...field}
                as="select"
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                size={size}
            >
                <option>{dropDownLabel}</option>
                {data?.map((item, idx) => (
                    <option value={item[dataValue]} key={idx}>
                        {dataDescription && item[dataDescription]} - {item[dataLabel]}
                    </option>
                ))}
            </Form.Control>
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BSelectField.defaultProps = {
    as: Col,
    data: [],
    dropDownLabel: null,
    md: 12,
    size: "md",
    dataLabel: "name",
    dataValue: "id"
};

export default BSelectField;
